<template>
  <el-container direction="vertical" style="height: auto" id="orderDetails">
    <el-row class="row-bg">
      <!-- 头部 -->
      <el-header>
        <el-col :span="24" style="text-align: center">
          <div>
            <span class="p-title">{{dataInfo.sellProductName}}</span>
          </div>
        </el-col>
      </el-header>
    </el-row>
    <el-main>
      <!-- 表单计划 -->
      <el-row>
        <el-col :span="16" :push="4">
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">基础信息</div></div>
              <el-form-item class="form-item-label" label="方案名称">
                <div>{{dataInfo.sellProductName}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="订单号码">
                <div>{{dataInfo.orderIdNum}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="保险期限">
                <div>自 {{dataInfo.effectiveDate}} 起至 {{dataInfo.expireDate}} 止</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="订单状态">
                <div>{{dataInfo.orderStatusChinese}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="订单人数">
                <div>{{dataInfo.beInsureSize}}人</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="保费">
                <div>{{dataInfo.orderPayMoney}}元</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card  v-if="isEjsino === false" class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">保障项目</div></div>
              <el-table
                :data="insureEnsureList"
                border
                max-height="500"
                class="my-el-table"
                style="margin-left: 0;text-align: center">
                <el-table-column
                  type="index"
                  label="保险计划"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="occName"
                  label="职业类别">
                </el-table-column>
                <el-table-column
                  prop="groupSize"
                  label="投保人数">
                </el-table-column>
                <el-table-column
                  prop="skuProductSpecValueList[3].specName"
                  label="意外伤害">
                </el-table-column>
                <el-table-column
                  prop="skuProductSpecValueList[4].specName"
                  label="意外伤害医疗">
                </el-table-column>
                <el-table-column
                  prop="skuProductSpecValueList[5].specName"
                  label="意外住院津贴">
                </el-table-column>
              </el-table>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">投保人信息</div></div>
              <el-form-item class="form-item-label" label="投保单位">
                <div>{{policyHolder.companyName}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="具体地址">
                <div>{{policyHolder.companyAddress}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="社会统一信用代码">
                <div>{{policyHolder.cardNum}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人姓名">
                <div>{{policyHolder.name}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人手机号码">
                <div>{{policyHolder.mobile}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人邮箱">
                <div>{{policyHolder.email}}</div>
              </el-form-item>
              <el-form-item v-if="$$.isValidObj(policyHolder.address)" class="form-item-label" label="联系人地址">
                <div>{{policyHolder.address}}</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">被保人信息</div></div>
              <el-table
                :data="insuredUserInfo"
                border
                style="width: 100%"
                v-if="isEjsino === false"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名">
                </el-table-column>
                <el-table-column
                  prop="cardType"
                  label="证件类型">
                </el-table-column>
                <el-table-column
                  prop="cardNum"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  prop="sex"
                  label="性别">
                </el-table-column>
                <el-table-column
                  prop="birthday"
                  label="出生日期">
                </el-table-column>
                <el-table-column
                  prop="realityOccCode"
                  label="职业代码">
                </el-table-column>
                <el-table-column
                  prop="relationship"
                  label="职业小分类">
                </el-table-column>
              </el-table>
              <span v-for="(item,index) in insuredUserInfoEjsino" :key="index" v-else>
                <el-table
                  :data="item.userData"
                  border
                  style="width: 100%"
                >
                <el-table-column
                  type="index"
                  label="序号"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名">
                </el-table-column>
                <el-table-column
                  prop="cardType"
                  label="证件类型">
                </el-table-column>
                <el-table-column
                  prop="cardNum"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  prop="sex"
                  label="性别">
                </el-table-column>
                <el-table-column
                  prop="birthday"
                  label="出生日期">
                </el-table-column>
                <el-table-column
                  prop="relationship"
                  label="职业小分类">
                </el-table-column>
               </el-table>
                <el-table
                  :data="item.remarkList"
                  border
                  style="width: 100%;margin-top: 20px;margin-bottom: 20px"
                >
                <el-table-column
                  v-for="(value,key) in item.remark"
                  :key="key"
                  :label="key"
                  :prop="key"
                  :width="key.length * 15">
                </el-table-column>
               </el-table>
              </span>
            </el-form>
          </el-card>
          <el-card class="box-card" v-if="JSON.stringify(orderMailInvoiceInfo) != '{}'">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">发票信息</div></div>
              <el-form-item class="form-item-label" label="发票类型">
                <div>{{orderMailInvoiceInfo.receiptType == 1?"增值税专用发票（纸质发票）":"普通发票（电子发票）"}}</div>
              </el-form-item>
              <span v-if="orderMailInvoiceInfo.receiptType != 1">
                <el-form-item class="form-item-label" label="发票抬头">
                  <div>{{policyHolder.companyName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="纳税人识别号">
                  <div>{{$$.isValidObj(orderMailInvoiceInfo.remark.tIN) ? orderMailInvoiceInfo.remark.tIN : policyHolder.cardNum}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人姓名">
                  <div>{{orderMailInvoiceInfo.rName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人手机号">
                  <div>{{orderMailInvoiceInfo.rPhone}}</div>
                </el-form-item>
                <el-form-item v-if="$$.isValidObj(orderMailInvoiceInfo.rMail)" class="form-item-label" label="收件人邮箱">
                  <div>{{orderMailInvoiceInfo.rMail}}</div>
                </el-form-item>
              </span>
              <span v-else>
                <el-form-item class="form-item-label" label="发票抬头">
                  <div>{{policyHolder.companyName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="纳税人识别号">
                  <div>{{orderMailInvoiceInfo.remark.tIN}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="税务登记地址">
                  <div>{{orderMailInvoiceInfo.remark.tRA}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="税务登记电话">
                  <div>{{orderMailInvoiceInfo.remark.tRT}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="开户银行">
                  <div>{{orderMailInvoiceInfo.remark.openBank}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="银行账户">
                  <div>{{orderMailInvoiceInfo.remark.bankNum}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人姓名">
                  <div>{{orderMailInvoiceInfo.rName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人手机号">
                  <div>{{orderMailInvoiceInfo.rPhone}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人地址">
                  <el-select @change="rProvinceChange" v-model="orderMailInvoiceInfo.rProvinceId"
                             placeholder="请选择"
                             class="form-item-input my-input" :disabled="true" >
                  <el-option
                    v-for="item in chinaArea"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select @change="rCityChange" v-model="orderMailInvoiceInfo.rCityId" placeholder="请选择"
                           class="form-item-input my-input" :disabled="true" >
                  <el-option
                    v-for="item in orderMailInvoiceInfo.rCityList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="orderMailInvoiceInfo.rAreaId" placeholder="请选择"
                           class="form-item-input my-input" :disabled="true" >
                  <el-option
                    v-for="item in orderMailInvoiceInfo.rAreaList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="具体地址" class="form-item-label">
                  <el-input class="form-item-input my-input-left " style="max-width: 640px;"
                            v-model="orderMailInvoiceInfo.rAddress"
                            placeholder="请输入具体地址"
                            :disabled="true"
                  ></el-input>
                </el-form-item>
              </span>
            </el-form>
          </el-card>
          <el-card class="box-card" v-else>
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">发票信息</div></div>
              <el-form-item class="form-item-label" label="发票类型">
                <div>无发票</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">受益人信息</div></div>
              <el-form-item class="form-item-label" label="受益人">
                <div>法定受益人</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-row style="margin-bottom: 50px;text-align: center" v-if="dataInfo.orderStatus == 1 || dataInfo.orderStatus == 0">
            <el-button type="danger" round style="width: 240px;height: 40px;background: #FF7052;border-radius: 12px;" @click="onPay">立刻支付</el-button>
            <el-button v-if="dataInfo.orderStatus === 0 && isEjsino" type="danger" round style="width: 240px;height: 40px;background: #FF7052;border-radius: 12px;" @click="onEdit">编辑订单</el-button>
          </el-row>
          <el-row style="margin-bottom: 50px;text-align: center" v-if="isEjsino && dataInfo.orderStatus === 2 && JSON.stringify(orderMailInvoiceInfo) === '{}'">
            <el-button type="danger" round style="width: 240px;height: 40px;background: #FF7052;border-radius: 12px;" @click="requestInvoiceData('01')">发票申请</el-button>
          </el-row>
          <el-row style="margin-bottom: 50px;text-align: center" v-if="isEjsino && dataInfo.orderStatus === 2 && JSON.stringify(orderMailInvoiceInfo) !== '{}'">
            <el-button type="danger" round style="width: 240px;height: 40px;background: #FF7052;border-radius: 12px;" @click="requestInvoiceData('04')">发票预览</el-button>
            <el-button type="danger" round style="width: 240px;height: 40px;background: #FF7052;border-radius: 12px;" v-if="orderMailInvoiceInfo.receiptStatus === 6" @click="requestInvoiceData('03')">发票下载</el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-main>
    <el-dialog
      title="提示"
      :visible.sync="paymentCbk"
      :close-on-click-modal=false
      width="30%"
      center>
      <div style="font-size:18px;text-align: center">{{payMsg}}</div>
    </el-dialog>
  </el-container>
</template>

<script>
    export default {
        name: "orderDetails",
        data(){
          return{
            location:false,
            formInline:{
              orderToken:'',
            },
            isEjsino : '',
            productId : '',
            remark: {},
            dataInfo:{},
            //被保人信息
            insuredUserInfo:[],
            // E超市被保人信息
            insuredUserInfoEjsino:[],
            //投保人信息
            policyHolder:{},
            //发票信息
            orderMailInvoiceInfo:{},
            insureEnsureList: [],
            beShareToken : '',
            chinaArea: this.chinaLifeAccidentDistrict.chinaAreaList(),
            payMsg: '',
            paymentCbk: false,
            url: ''
          }
        },
        methods:{
          // -- 省份改变事件
          rProvinceChange() {
            this.$forceUpdate();
            this.chinaArea.forEach(item => {
              item.value === this.orderMailInvoiceInfo.rProvinceId ? this.orderMailInvoiceInfo.rCityList = item.children : [];
            });
            this.orderMailInvoiceInfo.rCityId = '';
            this.orderMailInvoiceInfo.rAreaId = '';
          },
          // -- 城市改变事件
          rCityChange() {
            this.$forceUpdate();
            this.orderMailInvoiceInfo.rCityList.forEach(item => {
              item.value === this.orderMailInvoiceInfo.rCityId ? this.orderMailInvoiceInfo.rAreaList = item.children : [];
            });
            this.orderMailInvoiceInfo.rAreaId = '';
          },
          getOrderDetails() {
            this.location = true;
            let url = this.$$.isValidObj(this.beShareToken) ? '/management/mobileInsuranceInfo/loadOrderDetail?orderToken='+encodeURIComponent(decodeURIComponent(this.formInline.orderToken)).replace(/%20/g,'%2B').replace(/\+/g,'%2B') + '&beShareToken='+encodeURIComponent(decodeURIComponent(this.beShareToken)).replace(/%20/g,'%2B').replace(/\+/g,'%2B') :
              '/management/mobileInsuranceInfo/loadOrderDetail?orderToken='+encodeURIComponent(decodeURIComponent(this.formInline.orderToken)).replace(/%20/g,'%2B').replace(/\+/g,'%2B');
            this.axios.post(url).then((response) => {
              let {success, datas, msg} = response.data;
              if (success){
                const {insuredUserInfo, policyHolder, insureEnsure, beShareToken, orderMailInvoiceInfo, productId, url} = datas;
                this.productId = productId;
                this.dataInfo = datas;
                this.insuredUserInfo = insuredUserInfo;
                this.policyHolder = policyHolder;
                this.insureEnsureList = insureEnsure;
                this.beShareToken = beShareToken;

                this.url = url;

                if(this.$$.isValidObj(orderMailInvoiceInfo)){
                  const {remark, rProvinceId, rAreaId, rCityId} = datas.orderMailInvoiceInfo;
                  this.orderMailInvoiceInfo = datas.orderMailInvoiceInfo;
                  if( remark.indexOf("{") > -1 ){
                    this.orderMailInvoiceInfo.remark = JSON.parse(remark);

                    let {tIN, tRT, tRA, bankNum, openBank} = JSON.parse(remark);
                    if (this.$$.isValidObj(tRT) && this.$$.isValidObj(tRA) && this.$$.isValidObj(bankNum) && this.$$.isValidObj(openBank)) {
                      this.orderMailInvoiceInfo.rProvinceId = rProvinceId.toString();
                      this.orderMailInvoiceInfo.rAreaId = rAreaId.toString();
                      this.orderMailInvoiceInfo.rCityId = rCityId.toString();
                    }
                  }
                  if (this.$$.isValidObj(rProvinceId)){
                    this.chinaArea.forEach(item => {
                      item.value === rProvinceId.toString() ? this.orderMailInvoiceInfo.rCityList = item.children : [];
                    });

                    this.orderMailInvoiceInfo.rCityList.forEach(item => {
                      item.value === rCityId.toString() ? this.orderMailInvoiceInfo.rAreaList = item.children : [];
                    });
                  }
                }
              }else {
                this.$message.error(response.data.msg);
              }
              this.ejsonoProductCheck();
              this.location = false;
            })
          },
          onEdit(){
            this.$router.push({name: 'ejsinoInsureDetails', query: {productId: this.productId,orderToken: this.formInline.orderToken }});
          },
          /**
           * 立刻支付
           * @param row
           */
          onPay(){
            let loadingInstance = this.Loading.service({fullscreen: true});
            this.axios.post('/management/mobileInsuranceInfo/orderPaymentBefore?orderToken='+encodeURIComponent(decodeURIComponent(this.formInline.orderToken)).replace(/%20/g,'%2B').replace(/\+/g,'%2B')+'&beShareToken='+ encodeURIComponent(this.beShareToken).replace(/%20/g,'%2B').replace(/\+/g,'%2B')).then((response) => {
              let data = response.data;
              if(data.success === true){
                if( this.isEjsino ){
                  let that = this;
                  this.axios.post('/management/mobileInsuranceInfo/bindSellBillAtCostHandler?orderToken=' + encodeURIComponent(decodeURIComponent(this.formInline.orderToken))).then((response) => {
                    const { success, msg, datas } = response.data;
                    if(success && this.$$.isValidObj(datas)){
                      const { payUrl } = datas;
                      window.open(payUrl, '_blank');
                      that.intervalwx = window.setInterval(() => {
                        setTimeout(this.payCheck(), 0)
                      }, 2000);
                    }else{
                      if("I0004" == msg){
                        this.$$.alert({message: "订单已经支付成功！", onOk: function () {
                            that.$router.push({name: 'employerOrderManagement'});
                          }
                        });
                        return;
                      }
                      this.$message.error(msg);
                    }
                    this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                      loadingInstance.close();
                    });
                  });
                }else{
                  let params = {
                    orderToken: data.datas.orderToken,
                    sellProductName: this.dataInfo.sellProductName
                  };
                  sessionStorage.setItem('orderPaymentParams', JSON.stringify(params));
                  this.$router.push({ name: 'orderPaymentType'});
                }
              }else{
                let msg = this.$$.constant.error_codes[data.msg];
                this.$message.info(data.msg);
              }
              this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                loadingInstance.close();
              });
            });
          },
          // 支付状态校验轮询/management/mobileOrderInfoLog/getOrderStatus
          payCheck(){
            const that_ = this;
            this.axios.post('/management/mobileOrderInfoLog/getOrderStatus?orderToken='+encodeURIComponent(decodeURIComponent(this.formInline.orderToken)).replace(/%20/g,'%2B').replace(/\+/g,'%2B')+'&shareToken='+ encodeURIComponent(decodeURIComponent(this.beShareToken)).replace(/%20/g,'%2B').replace(/\+/g,'%2B')).then((response) => {
              let data = response.data;
              if(data.success === true){
                if(data.datas.orderStatus === 2){
                  this.payMsg = '支付成功';
                  const that = this;
                  that_.getOrderDetails();
                  this.paymentCbk = true;
                  clearInterval(that.intervalwx);
                  that.intervalwx = null;
                }
              }
            });
          },
          /**
           * e超市产品校验
           */
          ejsonoProductCheck(){
            this.insuredUserInfoEjsino = [];
            this.axios.post('/management/mobileInsuranceInfo/ejsonoProductCheck?productId='+this.productId).then((response) => {
              let data = response.data;
              this.isEjsino = data.success === true;

              if( this.isEjsino ){
                this.insuredUserInfo.forEach(item => {
                  if (this.$$.isValidObj(item.remark)) {
                    let map = JSON.parse(item.remark);
                    let remark = {};
                    for (let remarkKey in map) {
                      for (let o in this.ejsinoProElementInfo.ProElementInfo) {
                        if (remarkKey === o) {
                          remark[this.ejsinoProElementInfo.ProElementInfo[o]] = map[remarkKey];
                        }
                      }
                    }
                    item.remark = remark;
                  }
                });

                // 根据remark拆分
                let json = {};
                for(let i = 0; i < this.insuredUserInfo.length; i++){
                  if(!json[this.insuredUserInfo[i].remark]){
                    this.insuredUserInfoEjsino.push({"remark":this.insuredUserInfo[i].remark});
                    json[this.insuredUserInfo[i].remark] = 1;
                  }
                }
                this.insuredUserInfoEjsino.forEach(item => {
                  item.userData = [];
                  this.insuredUserInfo.forEach(user => {
                    if ( JSON.stringify(item.remark) === JSON.stringify(user.remark) ){
                      item.userData.push(user);
                    }
                  });
                  let map = {};
                  for( let o in item.remark ){
                    map[o] = item.remark[o];
                  }
                  item.remarkList = [];
                  item.remarkList.push(map);
                });
              }
            });
          },
          /**
           * e超市发票相关操作
           */
          requestInvoiceData(invoiceType){
            if( invoiceType === '03' ){
              this.axios.post('/management/mobileInsuranceInfo/requestInvoiceData?orderToken=' + encodeURIComponent(decodeURIComponent(this.formInline.orderToken)) +'&invoiceType=' +invoiceType).then((response) => {
                let data = response.data;
                if(data.success){
                  window.open(data.datas.url, '_blank');
                }else {
                  this.getOrderDetails();
                  this.$message.error(data.msg);
                }
              });
            }else {
              this.$router.push({name: 'ejsinoInsureDetails', query: {invoiceType: invoiceType,  orderToken: encodeURIComponent(decodeURIComponent(this.formInline.orderToken))}});
            }
          }
        },
        mounted() {
          if( this.$$.isValidObj(this.$route.query.isReload) ){
            let topHref = top.location.href.substring(0,top.location.href.indexOf("/#/"));
            top.location.href = topHref + location.href.substring(location.href.indexOf("/#/"), location.href.length);
          }
          this.formInline.orderToken = this.$route.query.orderToken;
          if( this.$$.isValidObj(this.$route.query.beShareToken) ){
            this.beShareToken = this.$route.query.beShareToken;
          }
          this.getOrderDetails();
        }
    }
</script>

<style scoped>
  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }
  .box-card-div-title.userInfo {
    width: 96px;
  }
  .box-card-div-title.supportPlan{
    width: 120px;
  }

  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
    display: inline-block;
    position: relative;
  }
  .p-title {
    font-size: 2.5rem;
    color: #333333;
    font-weight: bold;
    font-style: italic;
  }
  .p-present {
    font-size: 12px;
    font-weight: 500;
    font-style: italic;
    color: #666666;
  }
  .row-bg {
    padding: 60px 0 40px;
  }

  .form-item-label{
    font-size: 1rem;
    font-weight: 500;
    color: #333333;
    margin: 0 auto 5px;
  }
  .form-item-label div{
    width: 50%;
    font-size: 1rem;
    font-weight: 400;
    color: #333333;
    margin-left: 20px;
    border: 0 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  .el-table th>.cell{
    text-align: center!important;
  }

  .box-card-div-title>.header{
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }

  .el-table th{
    background: #EBEBEB!important;
  }

  /* 输入框去圆角 */
  .my-input /deep/ .el-input__inner {
    border: 0 !important;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  .my-input-left /deep/ .el-input__inner {
    border: 0 !important;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/orderDetails.vue